import { SPXAPI } from '../interfaces';
import { LinkDetails } from '../../types/types';
import { BASEURL, ENDPOINTS } from '../endpoints';

const getLinkData = async (API: SPXAPI, linkId: string): Promise<LinkDetails> => (
    API.get(BASEURL.backend(), ENDPOINTS.getLinkDetails(linkId), {})
);

export default getLinkData;
